<template>
  <div class="container mt-5 basics-100 text-center text-body-1 basics-20-bg">
    <div v-if="loading" class="mt-3 text-center">
      <h5>Veuillez patienter...</h5>
    </div>
    <div v-else>
      <div v-if="user && user.user_info" class="pb-5">
        Vous allez vous connecter en tant que :
        <h4 class="text-h4 font-demi-bold mt-3" style="text-transform: capitalize;">
          {{ user.user_info.family_name.toUpperCase() + ' ' + user.user_info.given_name }}
        </h4>
        <div class="d-flex flex-column align-items-center mt-2">
          <div class="d-inline-flex align-items-center p-0 basics-90">
            <icon-birth-day />
            <span class="ml-1">{{ moment(user.user_info.birthdate).format('DD/MM/YYYY') }}</span>
            <div v-if="user.user_info.gender === 'male'" class="ml-5">
              <icon-male />
              <span class="ml-1 mt-1">{{ 'Homme' }}</span>
            </div>
            <div v-else-if="user.user_info.gender === 'female'">
              <icon-female />
              <span class="ml-1">{{ 'Femme' }}</span>
            </div>
            <div v-else>
              <icon-other />
              <span class="ml-1">{{ 'Autre' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-5">
        <div class="d-flex justify-content-center">
          <span class="text-body-1 mb-2">Veuillez définir un mot de passe :</span>
        </div>
        <div class="d-inline-flex mt-2 justify-content-center flex-column w-30">
          <!-- Password input -->
          <label class="label">Mot de passe</label>
          <div class="d-flex align-items-center position-relative w-100 mb-4">
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              class="w-100 input"
            >
            <button
              class="btn btn-link-primary password position-absolute"
              style="right: 2px; top: 50%; transform: translateY(-50%);"
              @click="toggleShowPassword"
            >
              <icon-eye-open v-if="showPassword" />
              <icon-eye-close v-else />
            </button>
          </div>
          <!-- Confirm password input -->
          <label class="label">Confirmer le mot de passe</label>
          <div class="d-flex align-items-center position-relative w-100 mb-2">
            <input
              v-model="confirmPassword"
              :type="showConfirmPassword ? 'text' : 'password'"
              class="w-100 input"
            >
            <button
              class="btn btn-link-primary password position-absolute"
              style="right: 2px; top: 50%; transform: translateY(-50%);"
              @click="toggleConfirmPassword"
            >
              <icon-eye-open v-if="showConfirmPassword" />
              <icon-eye-close v-else />
            </button>
          </div>
          <div class="mb-3">
            <small v-if="errorPassword.length > 0" class="text-danger">{{ errorPassword }}</small>
          </div>
          <!-- Validate button -->
          <div class="d-flex justify-content-center">
            <button class="btn btn-primary align-items-end" @click.prevent="validate()">
              Valider
            </button>
          </div>
        </div>
        <div class="mt-3">
          <label class="text-caption basics-90">
            {{ HELP_MESSAGE }}
          </label>
        </div>
      </div>
      <button class="btn btn-link-primary mt-2" @click="logout()">
        Ce n'est pas vous? Cliquez ici
      </button>
    </div>
  </div>
</template>
  
  
<script>
import AuthService from "../../services/auth.service";
import IconBirthDay from "@/assets/icons/IconBirthDay";
import IconFemale from "../../assets/icons/IconFemale.vue";
import IconMale from "../../assets/icons/IconMale.vue";
import IconOther from "../../assets/icons/IconOther.vue";
import IconEyeClose from "../../assets/icons/IconEyeClose.vue";
import IconEyeOpen from "../../assets/icons/IconEyeOpen.vue";
import moment from "moment";
import { GENERIC_MAGIC_TOKEN_MESSAGE, GENERIC_MESSAGE, LOG_AUTH_CODES, HELP_MESSAGE } from '../../enums/logAuthEnum.js';

  export default {
    name: 'MagicPassword',
    components: {IconBirthDay, IconFemale, IconMale, IconOther, IconEyeClose, IconEyeOpen},
    data () {
        return {
          password: '',
          errorPassword: '',
          loading: true,
          moment,
          showPassword: false,
          confirmPassword: '',
          showConfirmPassword: false,
          HELP_MESSAGE
        };
    },
  
    computed: {
      user() {
        return AuthService.getUserInfos();
      },
    },

    mounted() {
        this.loading = true;
        let isMagicToken = sessionStorage.getItem("isMagicToken");
        if(!this.$route.query.token && !isMagicToken){
            sessionStorage.setItem("error", LOG_AUTH_CODES.MAGIC_URL_NOT_TOKEN_IN_PARAMS);
            this.$router.push({name: 'Login'});
        } else if (this.$route.query.token) {
            AuthService.magic_token({token: this.$route.query.token}).then(
                response => {
                    if(response.access_token && response.id_token) {
                        var user = AuthService.getUserInfos();
                        if(user) {
                            sessionStorage.setItem("isMagicToken", true);
                            this.$router.push({name: 'Auth'});
                        } else {
                            sessionStorage.setItem("error", LOG_AUTH_CODES.FC_NO_MATCHING_USER);
                        }
                    }
                }
            ).catch((error) => {
                sessionStorage.removeItem("isMagicToken");
                var err = Object.values(LOG_AUTH_CODES).find(item => error.response.data[item.code]);
                err = err ? err.code : GENERIC_MAGIC_TOKEN_MESSAGE.code;
                sessionStorage.setItem("error", err);
                this.$router.push({name: 'Login'});
            }).finally(() => {
                sessionStorage.removeItem("isMagicToken");
            });
        } else {
            this.loading = false;
            sessionStorage.removeItem("isMagicToken");
        }
    },
  
    methods: {
      toggleShowPassword() {
        this.showPassword = !this.showPassword;
      },

      toggleConfirmPassword() {
        this.showConfirmPassword = !this.showConfirmPassword;
      },

      logout() {
        AuthService.logout();
      },
  
      validate() {

        if(this.password !== this.confirmPassword) {
          this.errorPassword = "Les mots de passe ne correspondent pas.";
        } else if (this.password.length < 10 || this.password.toLowerCase() === this.password || this.password.toUpperCase() === this.password || !/\d/.test(this.password) || !/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.password)){
          this.errorPassword = "Le mot de passe doit contenir minimum 10 caractères, dont 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial.";
        } else if(this.password.length === 0) {
          this.errorPassword = "Veuillez saisir un mot de passe";
        } else {
          AuthService.updatePasswordUser(this.user.user_id, {password: this.password}).then(() => {
            this.$router.push({name: 'Profil'});
          }).catch(() => {
            sessionStorage.removeItem("isMagicToken");
            sessionStorage.setItem("error", GENERIC_MESSAGE);
            this.$router.push({name: 'Login'});
          });
        }
      },
    }
  };
  </script>